import * as React from "react";

import { AnsweredQuestionWithId } from "@teamprevent/common/model";

import { connect } from "react-redux";

import { submitReferralClinicalNotes, saveReferralClinicalNotes } from "../actions";

import { ClinicalNotes, questionnaireKey } from "./ClinicalNotes";
import { OldReferralClinicalNotesSections } from "./OldReferralClinicalNotesSections";

const intro = `I am an Occupational Health Advisor with Optima Health working on behalf of your employer.
    I am calling as your manager has referred you to Occupational Health in order to determine how best to support you.
    My role is to assess your current health situation and to provide advice to you and your manager. Is it convenient to talk?`;

interface DispatchProps {
    submitQuestionnaire: (ohCaseId: string, taskId: string, customerId: string, questions: AnsweredQuestionWithId[]) => void;
    saveQuestionnaire?: (ohCaseId: string, taskId: string, customerId: string, questions: AnsweredQuestionWithId[], eTag: string) => void;
}

export class OldReferralClinicalNotesUnconnected extends React.Component<DispatchProps> {

    public render() {
        return (
            <ClinicalNotes
                intro={intro}
                submitQuestionnaire={this.props.submitQuestionnaire}
                saveQuestionnaire={this.props.saveQuestionnaire}
            >
                <OldReferralClinicalNotesSections />
            </ClinicalNotes>
        );
    }
}

const mapDispatchToProps = (dispatch: any) => ({
    submitQuestionnaire: (ohCaseId: string, taskId: string, customerId: string, questions: AnsweredQuestionWithId[]) =>
        dispatch(submitReferralClinicalNotes(ohCaseId, taskId, customerId, questions, questionnaireKey)),
    saveQuestionnaire: (ohCaseId: string, taskId: string, customerId: string, questions: AnsweredQuestionWithId[], eTag: string) =>
        dispatch(saveReferralClinicalNotes(ohCaseId, taskId, customerId, questions, eTag))
});

export const OldReferralClinicalNotes = connect(null, mapDispatchToProps)(OldReferralClinicalNotesUnconnected);
